/**
 * @generated SignedSource<<8b488c5bb334f76db16b5b0b46b0d57e>>
 * @relayHash 8b64e3d6c365d87fa02a5d512eef63c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2f9a26a26830510346719b87b110bfb2dea343e96245b8c57eb7798ba510c50

import type { ConcreteRequest } from 'relay-runtime';
export type EditorContentStateComponentDisableCustomContentStateMutation$variables = {
  cloudId: string;
  contentStateId: string;
};
export type EditorContentStateComponentDisableCustomContentStateMutation$data = {
  readonly confluence_disableCustomContentState: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type EditorContentStateComponentDisableCustomContentStateMutation = {
  response: EditorContentStateComponentDisableCustomContentStateMutation$data;
  variables: EditorContentStateComponentDisableCustomContentStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStateId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentStateId",
        "variableName": "contentStateId"
      }
    ],
    "concreteType": "ConfluenceDisableCustomContentStatePayload",
    "kind": "LinkedField",
    "name": "confluence_disableCustomContentState",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorContentStateComponentDisableCustomContentStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorContentStateComponentDisableCustomContentStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b64e3d6c365d87fa02a5d512eef63c1",
    "id": "d2f9a26a26830510346719b87b110bfb2dea343e96245b8c57eb7798ba510c50",
    "metadata": {},
    "name": "EditorContentStateComponentDisableCustomContentStateMutation",
    "operationKind": "mutation",
    "text": "mutation EditorContentStateComponentDisableCustomContentStateMutation($cloudId:ID!,$contentStateId:ID!){confluence_disableCustomContentState(cloudId:$cloudId,contentStateId:$contentStateId){success,errors{message}}}"
  }
};
})();

(node as any).hash = "d551accdb1f708ca5aa4d407b67ebc48";

export default node;
